export default __webpack_public_path__ + "static/media/spaceTut.960e4387.png";